import { render } from "./menuList.vue?vue&type=template&id=094410a4&scoped=true"
import script from "./menuList.vue?vue&type=script&lang=js"
export * from "./menuList.vue?vue&type=script&lang=js"

import "./menuList.vue?vue&type=style&index=0&id=094410a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094410a4"]])

export default __exports__